import React from 'react';
import type { ViewProps } from 'react-native';
import { Form, LoadingPlaceholder } from '@sweetgreen/garnish';

// ────────────────────────────────────────────────────────────────────────────────

export const JoinScreenLoading = ({ testID }: JoinScreenLoadingProps) => (
  <Form.Container testID={testID}>
    <LoadingPlaceholder
      rows={8}
      rowHeight={[100, 60, 70, 70, 70, 70, 70, 80]}
      palette="cream"
    />
  </Form.Container>
);

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type JoinScreenLoadingProps = Pick<ViewProps, 'testID'>;
